import React, { useEffect, useState } from "react";
import { ApprovedIcon, RejectIcon, noResultIcon } from "../../../assets/images";
import { SingleJobsScheduledHoursListType } from "../../../redux/scheduling/schedulingTypes";
import { CircularAvatar, TableLoader } from "../../commons";
import JobSummaryDetails from "./JobSummaryDetails";
import JobWorkingUsersTable from "./JobWorkingUsersTable";
import "./jobClosure.scss";
import { JobClosureRatingListType } from "../../../redux/thinksToDo/thinksToDoType";
import {
  formateDateAndTime,
  formateLocalDateAndTime,
  reverseDate,
} from "../../../utils/commonFunctions";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import moment from "moment";
type AppProps = {
  data: SingleJobsScheduledHoursListType[] | [];
  activeTab: string;
  jobProgressCommentsFetching: boolean;
  jobFetching?: boolean;
  jobProgressCommentsList: any;
  documentsLinkList: any;
  renderAllRecordings: () => void;
  renderAllComments: () => void;
  renderAllViewChecklist: () => void;
  renderAllparticulerJobUsers: () => void;
  renderTabs: () => void;
  fetching: boolean;
  singleJobsData: any;
  singleJobScheduledHoursSum: number;
  showCommentBox: boolean;
  comment: string;
  handleCommentChange: (data: any) => void;
  handleReject: () => void;
  handleApprove: () => void;
  handleRejectWithComment: (data: any) => void;
  setParticulerjobsUsersList: React.Dispatch<
    React.SetStateAction<SingleJobsScheduledHoursListType[] | []>
  >;
  viewJobDetailsType?: string;
  isPendingApprovalApproveOrRejectButtonPresent: boolean;
  jobClosureRatingList: JobClosureRatingListType | null;
  handleCloseJobByRM: (data: any) => void;
  toggleModal: () => void;
  handleSentJobForClosuring?: (data: any) => void;
  jobCompletionTab: boolean | undefined;
  loginData: LoginResponseType;
  totalHours: number | string;
  openJobChargedHoursTimesheetTotalSum: number;
  isAllOpenJobCheckListDetailPresent?: boolean;
};
const ViewJobClosureJobDetails = ({
  data,
  activeTab,
  renderAllparticulerJobUsers,
  jobProgressCommentsFetching,
  jobFetching,
  jobProgressCommentsList,
  documentsLinkList,
  renderAllComments,
  renderAllViewChecklist,
  renderAllRecordings,
  renderTabs,
  fetching,
  singleJobsData,
  singleJobScheduledHoursSum,
  showCommentBox,
  comment,
  handleCommentChange,
  handleReject,
  handleApprove,
  handleRejectWithComment,
  setParticulerjobsUsersList,
  viewJobDetailsType,
  jobClosureRatingList,
  handleCloseJobByRM,
  jobCompletionTab,
  loginData,
  totalHours,
  toggleModal,
  isPendingApprovalApproveOrRejectButtonPresent,
  handleSentJobForClosuring,
  openJobChargedHoursTimesheetTotalSum,
  isAllOpenJobCheckListDetailPresent,
}: AppProps) => {
  const [buttonDisable, setButtonDisable] = useState(false);
  useEffect(() => {
    let filterData: any =
      data?.length > 0 &&
      data?.map((user: SingleJobsScheduledHoursListType) => {
        if (!user?.rating) {
          return true;
        } else if (+user?.rating < 4 && !user?.comment?.trim()) {
          return true;
        } else {
          return false;
        }
      });
    let isDisable =
      filterData?.length > 0 && filterData?.find((el: boolean) => el === true);

    setButtonDisable(isDisable ? isDisable : false);
  }, [data]);

  return (
    <>
      <JobSummaryDetails
        data={singleJobsData}
        singleJobScheduledHoursSum={openJobChargedHoursTimesheetTotalSum}
      />
      <div style={{ display: "flex", width: "100%", gap: "4%" }}>
        <div style={{ width: "58%" }}>
          <div className="row">
            <div className="col-md-10 pl-4">
              <div
                style={{
                  borderRadius: "5px 5px 0 0",
                  padding: "0px 35px",
                }}
              >
                <div
                  className="d-flex"
                  style={{
                    borderBottom: "2px solid #bfcbe1",
                    paddingTop: "17px",
                    width: "120%",
                  }}
                >
                  {renderTabs()}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              borderTop: "none",
              paddingTop: "1rem",
              paddingLeft: "33px",
              paddingBottom: "15px",
            }}
          >
            {activeTab === "viewChecklist" ? (
              <>{renderAllViewChecklist()}</>
            ) : activeTab === "allComments" ? (
              jobProgressCommentsFetching ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : !!jobProgressCommentsList &&
                jobProgressCommentsList.length > 0 ? (
                <div className="w-100 comment-area">{renderAllComments()}</div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    paddingBottom: "6rem",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={noResultIcon} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span> There are no comments here. </span>
                  </div>
                </div>
              )
            ) : activeTab === "userWorkingJob" ? (
              <>{renderAllparticulerJobUsers()}</>
            ) : jobProgressCommentsFetching ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : !!documentsLinkList && documentsLinkList.length > 0 ? (
              <div className="w-100 comment-area">{renderAllRecordings()}</div>
            ) : (
              // <div className="w-100 text-center due-date-text">No Links!</div>
              <div
                style={{
                  display: "flex",
                  paddingBottom: "6rem",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={noResultIcon} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span> There are no links here. </span>
                </div>
              </div>
            )}
          </div>
          {/* )} */}
        </div>
        {viewJobDetailsType === "manager" ? (
          <div
            style={{
              width: "48%",
              border: "1px solid #bfcbe1",
              margin: "33px 33px 0px 27px",
              backgroundColor: "#F4F6F8",
            }}
          >
            <p
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#262a44",
                textAlign: "left",
                padding: "10px 0px 0px 10px",
              }}
            >
              List of employees who worked on this job
            </p>

            <JobWorkingUsersTable
              data={data}
              fetching={fetching}
              setParticulerjobsUsersList={setParticulerjobsUsersList}
              setButtonDisable={setButtonDisable}
              totalHours={totalHours}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      {/* <hr /> */}
      {viewJobDetailsType === "manager" &&
        isPendingApprovalApproveOrRejectButtonPresent ? (
        <>
          <p
            style={{
              color: "#6e7491",
              fontSize: "13px",
              fontWeight: "500",
              margin: "25px 0px 14px 37px",
            }}
          >
            By clicking approve will send this job to RM team for closure.
          </p>
          <div className="d-flex pb-5" style={{ flexDirection: "column" }}>
            <div className="d-flex">
              <button
                style={{
                  cursor: buttonDisable ? "auto" : "pointer",
                  margin: "0px 10px 0px 30px",
                  border: "none",
                  backgroundColor: "white",
                  display: "flex",
                  alignItems: "center",
                }}
                disabled={buttonDisable}
                onClick={() => {
                  handleApprove();
                }}
              >
                <img
                  style={{
                    color: buttonDisable ? "rgba(221, 68, 51, 0.5)" : "#dd4433",
                  }}
                  src={ApprovedIcon}
                  alt="approved-icon"
                />
                <span
                  className="ml-2"
                  style={{
                    color: buttonDisable ? "rgba(221, 68, 51, 0.5)" : "#dd4433",
                    fontSize: "16px",
                    fontWeight: 500,

                    cursor: buttonDisable ? "auto" : "pointer",
                  }}
                >
                  Approve
                </span>
              </button>
              <span
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => {
                  handleReject();
                }}
              >
                <img src={RejectIcon} alt="reject-icon" />
                <span className="ml-2">Reject</span>
              </span>
            </div>

            {showCommentBox && (
              <div className="comment-box">
                <span>
                  Add your comment here <span className="color-red">*</span>
                </span>
                <textarea
                  value={comment}
                  onChange={handleCommentChange}
                  className="comment-textarea"
                  rows={4}
                  cols={65}
                />
                <button
                  onClick={() =>
                    handleRejectWithComment(singleJobsData?.job_id)
                  }
                  className="btn btn-primary"
                  disabled={!comment?.trim()}
                >
                  Reject with Comment
                </button>
              </div>
            )}
            {jobClosureRatingList?.rating_comment && (
              <div style={{ padding: "20px 0px 20px 34px" }}>
                <hr />
                <div
                  className="mb-3"
                  style={{ color: "#262a44", fontWeight: "500" }}
                >
                  My Previous Rejection Comments
                </div>
                <div className="d-flex">
                  {/* <div></div> */}
                  <CircularAvatar
                    image={
                      jobClosureRatingList?.job_manager?.profile_pic
                        ? jobClosureRatingList?.job_manager?.profile_pic
                          ?.file_url
                        : ""
                    }
                    name={`${jobClosureRatingList?.job_manager?.first_name} ${jobClosureRatingList?.job_manager?.last_name
                        ? jobClosureRatingList?.job_manager?.last_name
                        : ""
                      }`}
                  />
                  <div className="ml-2">
                    <div className="mb-2">
                      {`${jobClosureRatingList?.job_manager?.first_name} ${jobClosureRatingList?.job_manager?.last_name
                          ? jobClosureRatingList?.job_manager?.last_name
                          : ""
                        }`}
                      <span className="ml-2">
                        {jobClosureRatingList?.approval_updated_at
                          ? moment
                            .utc(jobClosureRatingList?.approval_updated_at)
                            .local()
                            .format("DD-MM-YYYY, hh:mm:ss A")
                          : null}
                      </span>
                    </div>
                    <div style={{ color: "#262a44" }}>
                      {jobClosureRatingList?.rating_comment}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        viewJobDetailsType === "Employee" &&
        jobCompletionTab &&
        loginData?.user_id !== singleJobsData?.job_manager?.user_id && (
          <div className="col-md-6 mt-5 ml-4 mb-5">
            {/* <hr /> */}
            {/* FUTURE USE */}
            {/* <button
              onClick={() => {
                handleSentJobForClosuring?.(singleJobsData);
                toggleModal();
              }}
              className="btn btn-primary pt-2 pb-2 pl-4 pr-4"
              disabled={
                singleJobsData?.internal_status == 1 ||
                singleJobsData?.internal_status == 3
              }
            >
              Send For Approval
            </button> */}
            {jobClosureRatingList?.rating_comment && (
              <div style={{ padding: "20px 0px 20px 34px" }}>
                <hr />
                <div
                  className="mb-3"
                  style={{ color: "#262a44", fontWeight: "500" }}
                >
                  Manager Job Rejection Comments
                </div>
                <div className="d-flex">
                  {/* <div></div> */}
                  <CircularAvatar
                    image={
                      jobClosureRatingList?.job_manager?.profile_pic
                        ? jobClosureRatingList?.job_manager?.profile_pic
                          ?.file_url
                        : ""
                    }
                    name={`${jobClosureRatingList?.job_manager?.first_name} ${jobClosureRatingList?.job_manager?.last_name
                        ? jobClosureRatingList?.job_manager?.last_name
                        : ""
                      }`}
                  />
                  <div className="ml-2">
                    <div className="mb-2">
                      {`${jobClosureRatingList?.job_manager?.first_name} ${jobClosureRatingList?.job_manager?.last_name
                          ? jobClosureRatingList?.job_manager?.last_name
                          : ""
                        }`}
                      <span className="ml-2">
                        {jobClosureRatingList?.approval_updated_at
                          ? moment
                            .utc(jobClosureRatingList?.approval_updated_at)
                            .local()
                            .format("DD-MM-YYYY, hh:mm:ss A")
                          : null}
                      </span>
                    </div>
                    <div style={{ color: "#262a44" }}>
                      {jobClosureRatingList?.rating_comment}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )
      )}
    </>
  );
};

export default ViewJobClosureJobDetails;
